export const MDT_REFRESH_INTERVAL = 5 * 1000;
